import { Helmet } from 'react-helmet-async';
import { newsData } from '../newsData';
import NavigationButtons from '../navigationButtons';
import Content from './537.jpg';

const NachaloTepla2526 = () => {
  const pathname = window.location.pathname;
  const currentNewsIndex = newsData.findIndex(item => pathname.includes(item.url));

  const prevNewsIndex = currentNewsIndex > 0 ? currentNewsIndex - 1 : null;
  const nextNewsIndex = currentNewsIndex < newsData.length - 1 ? currentNewsIndex + 1 : null;

  const currentNews = newsData[currentNewsIndex];

  return (
    <article>
      <Helmet defer={false}>
        <title>О начале отопительного периода 2025–2026 гг. | ООО УК «ВЕХА»</title>
        <meta name="description" content="Постановление о начале отопительного периода 2025–2026 годов в домах под управлением УК ВЕХА." />
      </Helmet>
         <div>
      <h2 className='news_header'>ПОСТАНОВЛЕНИЕ О НАЧАЛЕ ОТОПИТЕЛЬНОГО ПЕРИОДА 2025-2026 ГГ.</h2>
      <div className='news_content'>
        <NavigationButtons prevNewsIndex={prevNewsIndex} nextNewsIndex={nextNewsIndex} />
       <p>Опубликовано {currentNews.date}</p>
        <img src={Content} width="60%" alt="Content" />
      </div>
    </div> 
    </article>

  );
};

export default NachaloTepla2526;